import { api } from '../api';
import { showBadToast, showGoodToast } from '../../errors/toast';
import { Recept } from '../../../models/Recept';
import { loadItem } from '@/models/DataHelper';
import {
    EquipmentStepsInfo,
    EquipmentStepInfo
} from '../../../models/BakInfo';

const actions = {
    //#region Recept
    async loadOpenRecipeInfo(context, data) {
        let tempList = [];
        try {
            await api.fetchOpenRecipeInfo(data.data).then((response) => {
                tempList = response.data.Items.map((x) => new Recept(x));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('com_beschikbaar', {
                        ns: 'common',
                        val: data.func('com_recipes', { ns: 'common' })
                    })
                }),
                error
            );
        }
        context.commit('insertRecipeInfoLijst', tempList);
    },
    async loadClosedRecipeInfo(context, data) {
        let tempList = [];
        try {
            await api.fetchClosedRecipeInfo(data.data).then((response) => {
                tempList = response.data.Items.map((x) => new Recept(x));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('com_gesloten', {
                        ns: 'common',
                        val: data.func('com_recipes', { ns: 'common' })
                    })
                }),
                error
            );
        }
        context.commit('insertClosedRecipeInfoLijst', tempList);
    },
    async loadRecipeComplete(context, data) {
        let item = null;
        try {
            const response = await api.fetchRecipeComplete(data.data);
            item = new Recept(response.data);
        } catch (error) {
            item = null;
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' })
                }),
                error
            );
        }
        context.commit('insertRecipe', item);
        return item;
    },
    async loadOpenRecipeComplete(context, data) {
        let item = null;
        try {
            const response = await api.fetchOpenRecipeComplete(data.data);
            item = new Recept(response.data);
        } catch (error) {
            item = null;
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' })
                }),
                error
            );
        }
        return item;
    },
    async saveRecipe(context, data) {
        try {
            await api.storeRecipe(data.data);
            loadItem('recipe/loadOpenRecipeInfo', null, data.func);
            context.commit('insertRecipe', data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' }).toLowerCase()
                }),
                error
            );
        }
    },
    async deleteRecipe(context, data) {
        try {
            await api.closeRecipe(data.data);
            context.commit('deleteRecipe', data.data);
            showGoodToast(
                context,
                data.func('com_verwijderd', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('com_recipe', { ns: 'common' })
                }),
                error
            );
        }
    },
    async loadLinkedOstData(context, data) {
        let tempList = [];
        try {
            await api.fetchLinkedOstData(data.data).then((response) => {
                tempList = response.data.map((x) => new EquipmentStepInfo(x));
            });
            // Set the duration of each following step; the final step has none.
            for (let i = 0; i < tempList.length; i++) {
                tempList[i].tijdsduurvolgende =
                    tempList[i + 1]?.tijdsduur ?? null;
            }
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_scaledata', { ns: 'production' })
                }),
                error
            );
        }
        return tempList;
    },
    //#endregion Recept

    //#region Merktype
    //#endregion Merktype

    //#region Coating
    //#endregion Coating

    //#region WheyType
    //#endregion WheyType

    //#region Ingredient
    //#endregion Ingredient
};

export default actions;

